import { Box, Drawer, IconButton, styled } from '@mui/material';

export const DrawerStyled = styled(Drawer)(({ theme }) => ({
  zIndex: 1300,
  '& .MuiDrawer-paper': {
    background: theme.palette.primaryLight.main,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 350,
    },
  },
}));

export const MenuWrapperStyled = styled(Box)(({ theme }) => ({
  width: '100vw',
  padding: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    width: 350,
  },
}));

export const IconButtonStyled = styled(IconButton)({
  padding: 0,
});

export const CloseButtonStyled = styled(IconButton)(({ theme }) => ({
  margin: `${theme.spacing(6)} ${theme.spacing(4)} 0 auto`,
}));
